exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-container {\n  margin-top: 70px; }\n  .admin-container .metric-box {\n    padding: .5em;\n    margin: 1em;\n    color: #FFFFFF;\n    border-radius: 3px;\n    display: flow-root; }\n  .admin-container .metric-box.color-1 {\n      background-color: #42CB93; }\n  .admin-container .metric-box.color-2 {\n      background-color: #42CB70; }\n  .admin-container .metric-box.color-3 {\n      background-color: #42CB7b; }\n  .admin-container .metric-box.color-4 {\n      background-color: #42CB9D; }\n  .admin-container .metric-box.color-5 {\n      background-color: #42CBA9; }\n  .admin-container .metric-box.color-6 {\n      background-color: #42CBB4; }\n  .admin-container .metric-box .metric-title {\n      padding: .5em;\n      font-size: 1.5em;\n      font-family: 'Nova Square'; }\n  .admin-container .metric-box .metric-count {\n      font-size: 4em;\n      text-align: right;\n      padding-right: .5em; }\n  .admin-container .update-date {\n    margin: 1em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/reports/admin/admin.component.scss
// module id = ../../../../../src/app/reports/admin/admin.component.scss
// module chunks = main